module.exports = __webpack_public_path__ + "img/1.8ec62875.png";